import { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Box, Button, Dialog, DialogContent, Slide, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

import CenterScreen from 'src/components/CenterScreen';
import LOCAL_KEYS from 'src/constants/localKeys';
import useUserStore from 'src/stores/user';
import { WithoutHeader, DesktopLayout } from 'src/layout';
import useIsMobileSize from 'src/hooks/useIsMobileSize';
import { ROUTES_URL } from 'src/constants/routes';
import useGoTo from 'src/hooks/useGoTo';

const messages = {
    h1: 'Добро пожаловать',
    sub: 'Вова пишет крутое приветсвие новых клиентов',
};

const useStyles = makeStyles(() =>
    createStyles({
        paper: {
            maxWidth: 700,
        },
        content: {
            paddingTop: 24,
            paddingBottom: 24,
            '& img': {
                maxWidth: '100%',
                height: 'auto',
                display: 'block',
            },
            '@media (min-width:600px)': {
                paddingTop: 32,
                paddingBottom: 32,
            },
        },
        emoji: {
            fontSize: 56,
            lineHeight: 1,
            display: 'inline-block',
            animation: '$float 3s ease-in-out infinite',
        },
        emojiStatic: {
            fontSize: 56,
            lineHeight: 1,
            display: 'inline-block',
        },
        emojiBounce: {
            animation: '$bounce 1.6s ease-in-out infinite',
        },
        emojiPulse: {
            animation: '$pulse 2s ease-in-out infinite',
        },
        '@keyframes float': {
            '0%': { transform: 'translateY(0)' },
            '50%': { transform: 'translateY(-6px)' },
            '100%': { transform: 'translateY(0)' },
        },
        '@keyframes bounce': {
            '0%, 100%': { transform: 'translateY(0)' },
            '50%': { transform: 'translateY(-10px)' },
        },
        '@keyframes pulse': {
            '0%': { transform: 'scale(1)' },
            '50%': { transform: 'scale(1.06)' },
            '100%': { transform: 'scale(1)' },
        },
    })
);

export default function WelcomeScreen({ referal = false }) {
    const isMobile = useIsMobileSize();
    const { isOnboardingCompleted } = useUserStore(({ isOnboardingCompleted }) => ({ isOnboardingCompleted }));
    const classes = useStyles();
    const [step, setStep] = useState(1);
    const goTo = useGoTo();

    if (referal) {
        messages.h1 = 'Привет вот тебе 300 баллов';
        messages.sub = 'Вова пишет крутое приветсвие новых клиентов';
    }

    const handleClick = () => {
        if (step === 4) {
            goTo(ROUTES_URL.BEGIN_WORK);
            return;
        }

        setStep((old) => (old += 1));
    };

    const renderFirstScreen = () => {
        return (
            <Slide
                in={step === 1}
                direction="right"
                timeout={{
                    enter: 800,
                    exit: 0,
                }}
                mountOnEnter
                unmountOnExit
            >
                <Box
                    height={260}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box mb={1}>
                        <span className={classes.emojiStatic}>🌍</span>
                    </Box>
                    <Box mb={3}>
                        <Typography
                            textAlign="center"
                            variant="h1"
                            color="primary"
                        >
                            Добро пожаловать
                        </Typography>
                    </Box>
                    <Box>
                        <Typography
                            textAlign="center"
                            variant="body1"
                            color="primary"
                        >
                            Более <strong>1 миллиарда человек</strong> пользуются Telegram по всему миру. <br />С ТГХ вы
                            легко находите тех, кто заинтересовался продуктом или услугой вашей тематики
                        </Typography>
                    </Box>
                </Box>
            </Slide>
        );
    };

    const renderSecondScreen = () => {
        return (
            <Slide
                in={step === 2}
                direction="right"
                timeout={{
                    enter: 800,
                    exit: 0,
                }}
                mountOnEnter
                unmountOnExit
            >
                <Box
                    height={260}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box mb={3}>
                        <Typography
                            textAlign="center"
                            variant="h1"
                            color="primary"
                        >
                            Как работает
                            <br /> сервис?
                        </Typography>
                    </Box>
                    <Box>
                        <Typography
                            textAlign="center"
                            variant="body1"
                            color="primary"
                        >
                            ТГХ <strong>круглосуточно мониторит</strong> чаты и группы в Telegram. Как только ваши
                            ключевые слова появляются в сообщениях — вы мгновенно получаете уведомление
                        </Typography>
                    </Box>
                </Box>
            </Slide>
        );
    };

    const renderThirdSceen = () => {
        return (
            <Slide
                in={step === 3}
                direction="right"
                timeout={{
                    enter: 800,
                    exit: 0,
                }}
                mountOnEnter
                unmountOnExit
            >
                <Box
                    height={260}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box mb={3}>
                        <Typography
                            textAlign="center"
                            variant="h1"
                            color="primary"
                        >
                            Новые лиды
                            <br /> для вашего бизнеса
                        </Typography>
                    </Box>
                    <Box>
                        <Typography
                            textAlign="center"
                            variant="body1"
                            color="primary"
                        >
                            Вы получаете возможность и преимущество — первым предложить ваш продукт или услугу.
                            Обрабатывайте свежие целевые запросы и <strong>увеличивайте рост продаж</strong>
                        </Typography>
                    </Box>
                </Box>
            </Slide>
        );
    };

    const renderFourthSceen = () => {
        return (
            <Slide
                in={step === 4}
                direction="right"
                timeout={{
                    enter: 800,
                    exit: 0,
                }}
                mountOnEnter
                unmountOnExit
            >
                <Box
                    height={260}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box mb={1}>
                        <span className={`${classes.emoji} ${classes.emojiBounce}`}>🎁</span>
                    </Box>
                    <Box mb={3}>
                        <Typography
                            textAlign="center"
                            variant="h1"
                            color="primary"
                        >
                            Начать легко!
                            <br />
                            Дарим 300 баллов
                        </Typography>
                    </Box>
                    <Box>
                        <Typography
                            textAlign="center"
                            variant="body1"
                            color="primary"
                        >
                            Получите <strong>300 бонусных баллов</strong> при старте — используйте их на любом тарифе
                            для поиска клиентов и оценки работы сервиса
                        </Typography>
                    </Box>
                </Box>
            </Slide>
        );
    };

    const renderButtonNext = () => {
        return (
            <Button
                onClick={handleClick}
                variant="contained"
                size="large"
                fullWidth
            >
                {step < 4 ? 'Далее' : 'Начать'}
            </Button>
        );
    };

    const renderDots = () => (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={3}
            mb={2}
            gap={1.5}
        >
            {[1, 2, 3, 4].map((i) => (
                <Box
                    key={i}
                    sx={{
                        width: step === i ? 12 : 10,
                        height: step === i ? 12 : 10,
                        borderRadius: '50%',
                        backgroundColor: step === i ? 'secondary.main' : '#C8D7E6',
                        boxShadow: step === i ? '0 0 0 3px rgba(25,118,210,0.15)' : 'none',
                        transition: 'all 0.25s ease',
                    }}
                />
            ))}
        </Box>
    );

    if (isOnboardingCompleted) {
        return <Redirect to="/" />;
    }

    return (
        <>
            {isMobile ? (
                <WithoutHeader showBack={false}>
                    <Dialog
                        onClose={() => {}}
                        open={true}
                        fullScreen
                    >
                        <DialogContent className={classes.content}>
                            <Box
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                height={300}
                                px={2}
                            >
                                {renderFirstScreen()}
                                {renderSecondScreen()}
                                {renderThirdSceen()}
                                {renderFourthSceen()}
                                {renderDots()}
                                <Box
                                    mt={2}
                                    maxWidth={360}
                                    mx="auto"
                                >
                                    {renderButtonNext()}
                                </Box>
                            </Box>
                        </DialogContent>
                    </Dialog>
                </WithoutHeader>
            ) : (
                <DesktopLayout>
                    <Dialog
                        onClose={() => {}}
                        open={true}
                        classes={{
                            paper: classes.paper,
                        }}
                    >
                        <DialogContent className={classes.content}>
                            <Box
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                height={300}
                            >
                                {renderFirstScreen()}
                                {renderSecondScreen()}
                                {renderThirdSceen()}
                                {renderFourthSceen()}
                                {renderDots()}
                                <Box mt={2}>{renderButtonNext()}</Box>
                            </Box>
                        </DialogContent>
                    </Dialog>
                </DesktopLayout>
            )}
        </>
    );
}
